import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { DateTime } from 'luxon';
import { MeetingNote } from './meeting-notes.js';

/**
 * @entity QuarterNoteQuestion
 */
@Entity()
export class QuarterNoteQuestion extends MongoEntity {
  public static override _class = 'QuarterNoteQuestion';
  public static override _collectionName = 'note-questions';

  @Field(type => String)
  public meetingNoteID: Maybe<string>;

  @DataLoadedField(type => MeetingNote, ({ meetingNoteID }) => meetingNoteID)
  public meetingNote: Maybe<MeetingNote>;

  @Field(type => String)
  public question: Maybe<string>;

  @Field(type => String)
  category: Maybe<string>;

  @Field(type => String)
  year: Maybe<string>;

  @Field(type => String)
  public anwser: Maybe<string>;

  @Field(type => DateTime)
  public answerDate: Maybe<DateTime>;

  @Field(type => String)
  public personAnsweredID: Maybe<string>;

  @DataLoadedField(type => ChancenwerkUser, ({ personAnsweredID }) => personAnsweredID)
  public personAnswered: Maybe<ChancenwerkUser>;

  // Only for product questions
  @Field(type => Boolean)
  isRunningGood: Maybe<boolean>;

  @Field(type => String)
  reason: Maybe<string>;

  @Field(type => DateTime)
  public plannedAt: Maybe<DateTime>;
}
